import { render } from "./CurrentRestaurantSettings.vue?vue&type=template&id=536ceee4&scoped=true"
import script from "./CurrentRestaurantSettings.vue?vue&type=script&lang=js"
export * from "./CurrentRestaurantSettings.vue?vue&type=script&lang=js"

import "./CurrentRestaurantSettings.vue?vue&type=style&index=0&id=536ceee4&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536ceee4"]])

export default __exports__